import { Injectable } from '@angular/core';
import { FeatureFlagService as FeatureFlagApiService } from '@galaxy/partner';
import { FeatureFlagStatusInterface } from '@galaxy/partner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class FeatureFlagMultiResponse {
  [key: string]: boolean;
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  constructor(private featureFlagService: FeatureFlagApiService) {}

  checkFeatureFlagsMulti(partnerId: string, marketId = '', featureIds: string[]): Observable<FeatureFlagMultiResponse> {
    return this.featureFlagService
      .batchGetStatus(partnerId, marketId, featureIds)
      .pipe(map((resp: FeatureFlagStatusInterface): FeatureFlagMultiResponse => resp as FeatureFlagMultiResponse));
  }

  checkFeatureFlag(partnerId: string, marketId = '', featureId: string): Observable<boolean> {
    return this.featureFlagService.batchGetStatus(partnerId, marketId, [featureId]).pipe(
      map((val: FeatureFlagMultiResponse): boolean => {
        return Object.prototype.hasOwnProperty.call(val, featureId) && val[featureId];
      }),
    );
  }
}
